import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_EVENT_BY_ID } from './actionTypes';
import { getPlcSafetyEventByIdSuccess, getPlcSafetyEventByIdError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getEventById({ payload: { user, eventId } }) {
  try {
    const response = yield call(plcSafetyAPI.getEventById, user.token, eventId);
    yield put(getPlcSafetyEventByIdSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyEventByIdError(error));
  }
}

export function* watchGetPlcSafetyEventById() {
  yield takeEvery(GET_PLC_SAFETY_EVENT_BY_ID, getEventById);
}

function* getPlcSafetyEventByIdSaga() {
  yield all([fork(watchGetPlcSafetyEventById)]);
}

export default getPlcSafetyEventByIdSaga;
